module.exports = __webpack_public_path__ + "img/15.0cc42c35.jpg";